// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const is = (type: any, val: any) =>
  ![undefined, null].includes(val) && val.constructor === type;
